import { RpcProtocolError } from "@solomon-labs/solana-rpc-client";

import type { LpRpc } from "./lpTypes";

const SLOT_RETRY_DELAYS_MS = [400, 800, 1600];

/** Retry node lag at the same slot floor; restarting discovery moves that floor forward. */
export async function requestLpRpc<T>(
    rpc: LpRpc,
    ...[method, params, options]: Parameters<LpRpc["request"]>
): Promise<T> {
    for (let attempt = 0; ; attempt++) {
        options?.signal?.throwIfAborted();
        try {
            return await rpc.request<T>(method, params, options);
        } catch (error) {
            const delay = SLOT_RETRY_DELAYS_MS[attempt];
            if (!(error instanceof RpcProtocolError) || error.code !== -32016 || delay === undefined) throw error;
            await waitForSlot(delay, options?.signal);
        }
    }
}

function waitForSlot(delay: number, signal?: AbortSignal): Promise<void> {
    signal?.throwIfAborted();
    return new Promise((resolve, reject) => {
        const abort = (): void => {
            clearTimeout(timer);
            reject(signal?.reason);
        };
        const timer = setTimeout(() => {
            signal?.removeEventListener("abort", abort);
            resolve();
        }, delay);
        signal?.addEventListener("abort", abort, { once: true });
    });
}
